import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { Club, ClubJSON } from './Club';
export class ClubSystem {
    private readonly base = '/clubs';
    constructor(private requestHandler: XhrRequestHandler) {
    }

    async getClubIdentifiedBy(id: string): Promise<Club> {
        const data = await this.requestHandler.get<ClubJSON>(`${this.base}/${id}`);
        return Club.fromJSON(data);
    }

    async getList(): Promise<Club[]> {
        const data = await this.requestHandler.get<ClubJSON[]>(`${this.base}`);
        return data.map((entity) => Club.fromJSON(entity))
    }

    async getListForDropdown(): Promise<Club[]> {
        const data = await this.requestHandler.get<ClubJSON[]>(`${this.base}/for-dropdown`);
        return data.map((entity) => Club.fromJSON(entity))
    }

    async getListForAutocomplete(searchKey: string): Promise<Club[]> {
        const data = await this.requestHandler.get<ClubJSON[]>(`${this.base}/for-autocomplete?searchKey=${searchKey}`);
        return data.map((entity) => Club.fromJSON(entity));
    }

    async save(entity: Club) {
        const data = entity.toJSON();
        const savedEntity = await this.requestHandler.post<ClubJSON, ClubJSON>(this.base, data);
        return Club.fromJSON(savedEntity);
    }

    getBaseUrlForDatagrid() {
        return this.requestHandler.requestUrl(`${this.base}/datagrid`)
    }

}

